import Model from './BaseModel.js';
import Price from './Price.js';
import Race from './Race.js';

export default class Selection extends Model {
	resourceName() {
		return 'selections';
	}

	fields() {
		return [
			'deductions',
			'display_price_flucs',
			'liabilities',
			'name',
			'number',
			'win_price_roll',
			'place_price_roll',
			'scratched_time',
			'selection_type',
			'status',
			'position',
			'starting_price',
			'top_fluc'
		];
	}

	relationships() {
		return {
			event: new Race(),
			prices: new Price()
		};
	}

	find(id) {
		return this.makeFetchRequest(`${this.baseUrl()}/racing_selections/${id}${this.queryBuilder.getQuery()}`);
	}

	// inject a special case to update 'price_roll'
	updatePriceRoll(value, betType) {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/racing_selections/${this.id}/price_roll`,
			method: 'POST',
			data: { price_roll: value, bet_type: betType }
		}).catch(() => {});
	}

	// inject a special case to update 'deductions'
	updateDeductions(data) {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/racing_selections/${this.id}/deductions`,
			method: 'POST',
			data
		});
	}

	scratch() {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/racing_selections/${this.id}/scratch`,
			method: 'POST'
		});
	}

	unscratch() {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/racing_selections/${this.id}/unscratch`,
			method: 'POST'
		});
	}

	updateSelection(data) {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/racing_selections/${this.id}`,
			method: 'POST',
			data
		});
	}

	unresult(data) {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/racing_selections/${this.id}/unfinalise`,
			method: 'POST',
			data
		});
	}
}
